import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import DestinationCard from "./DestinationCard";
import DestinationCardTwo from "./DestinationCardTwo";
import posts from "../data/data-destination.json";

function DestinationInner() {
  const [activeTab, setActiveTab] = useState("tab-grid");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState(""); // Search state
  const postsPerPage = 9;

  const containerRef = useRef(null); // Ref for scrolling

  // Pagination
  const totalPages = Math.ceil(posts.length / postsPerPage);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  // Filter posts based on search term
  const filteredPosts = currentPosts.filter((data) =>
    data.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Scroll to top of the container smoothly
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="space" ref={containerRef}>
      <div className="container">
        {/* Search & Tabs */}
        <div className="th-sort-bar">
          <div className="row justify-content-between align-items-center">
            {/* Search Input */}
            <div className="col-md-4">
              <div className="search-form-area">
                <input
                  type="text"
                  placeholder="Search by country"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>

            {/* Grid/List Tabs */}
            <div className="col-md-auto">
              <div className="sorting-filter-wrap">
                <div className="nav" role="tablist">
                  <Link
                    to="#"
                    className={activeTab === "tab-grid" ? "active" : ""}
                    onClick={() => setActiveTab("tab-grid")}
                  >
                    <i className="fa-light fa-grid-2" />
                  </Link>
                  <Link
                    to="#"
                    className={activeTab === "tab-list" ? "active" : ""}
                    onClick={() => setActiveTab("tab-list")}
                  >
                    <i className="fa-solid fa-list" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Destinations */}
        <div className="row">
          <div className="col-12">
            <div className="tab-content">
              {/* Grid View */}
              <div
                className={`tab-pane fade ${
                  activeTab === "tab-grid" ? "show active" : ""
                }`}
              >
                <div className="row gy-30">
                  {filteredPosts.length > 0 ? (
                    filteredPosts.map((data, index) => (
                      <div key={index} className="col-xxl-4 col-xl-6">
                        <DestinationCard
                          destinationID={data.id}
                          destinationImage={data.image}
                          destinationTitle={data.title}
                          // destinationPrice={data.price}
                        />
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center">
                      <h5>No results found for "{searchTerm}"</h5>
                    </div>
                  )}
                </div>
              </div>

              {/* List View */}
              <div
                className={`tab-pane fade ${
                  activeTab === "tab-list" ? "show active" : ""
                }`}
              >
                <div className="row gy-30">
                  {filteredPosts.length > 0 ? (
                    filteredPosts.map((data, index) => (
                      <div key={index} className="col-12">
                        <DestinationCardTwo
                          destinationID={data.id}
                          destinationImage={data.image}
                          destinationTitle={data.title}
                          // destinationPrice={data.price}
                        />
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center">
                      <h5>No results found for "{searchTerm}"</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Pagination */}
            <div className="th-pagination text-center mt-60 mb-0">
              <ul>
                {Array.from({ length: totalPages }, (_, i) => (
                  <li key={i}>
                    <Link
                      className={currentPage === i + 1 ? "active" : ""}
                      to="#"
                      onClick={() => handlePageChange(i + 1)}
                    >
                      {i + 1}
                    </Link>
                  </li>
                ))}
                {currentPage < totalPages && (
                  <li>
                    <Link
                      className="next-page"
                      to="#"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next <img src="/assets/img/icon/arrow-right4.svg" alt="" />
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DestinationInner;
